import { AppBar, Tab, Tabs } from "@material-ui/core";
import React from "react";
import { TabPanel } from "../../Analytics/Dashboard/views/AnalyticsDashboard";
import Base from "../../base/views/base";
import PhysicalInventoryReportWithLotNo from './PhysicalInventoryReportWithLotNo'
import PhysicalInventoryReportWithoutLotNo from "./PhysicalInventoryReportWithoutLotNo";

const PhysicalInventoryReport = () => {
  const [value, setValue] = React.useState(0);

  function a11yProps(index) {
    return {
      id: `scrollable-force-tab-${index}`,
      "aria-controls": `scrollable-force-tabpanel-${index}`,
    };
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div style={{ display: "flex" }}>
      <Base showBaseMenu={true} title="Physical Inventory">
        <AppBar style={{ marginTop: 50 }} position="static" color="transparent">
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            aria-label="scrollable force tabs example"
            centered
          >
            <Tab label="With Lot No." {...a11yProps(0)} />
            <Tab label="Without Lot No." {...a11yProps(1)} />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0}>
          <PhysicalInventoryReportWithLotNo />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <PhysicalInventoryReportWithoutLotNo />
        </TabPanel>
      </Base>
    </div>
  );
};

export default PhysicalInventoryReport;
